export default __webpack_public_path__ + "static-front/media/CalendarIcon.bbeac168.svg";